<ng-container *transloco="let t">
    <div class="sign-in-area">
        <div class="d-table">
            <div class="d-table-cell">
                <div
                    class="altair-form ml-auto mr-auto border-radius bg-white"
                    [class.card-borderd-theme]="themeService.isCardBorder()"
                    [class.component-dark-theme]="themeService.isDark()"
                >
                    <div class="title text-center">
                        <h3>
                            {{t('welcome')}} ALTAIR
                        </h3>
                        <p class="ml-auto mr-auto">
                            {{t('thank-you-for-using')}}
                        </p>
                    </div>
                    <div class="admin text-center">
                        <div class="logo position-relative rounded-circle bg-white">
                            <ng-container *ngIf="!themeService.isDark()">
                                <img src="assets/images/icono-intrust-security-ciberseguridad-claro.png" alt="logo">
                            </ng-container>
                            <ng-container *ngIf="themeService.isDark()">
                                <img src="assets/images/icono-intrust-security-ciberseguridad-oscuro.png" alt="logo">
                            </ng-container>
                        </div>
                    </div>
                    <form [formGroup]="authForm" (ngSubmit)="onSubmit()">
                        <div class="form-group">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('email-adress')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-email-address')}}
                                </mat-label>
                                <input matInput type="email" id="email" formControlName="email"  (keydown.enter)="onKeydown($event)">
                            </mat-form-field>
                            <div class="error text-danger" *ngIf="authForm.get('email')!.hasError('required') && authForm.get('email')!.touched">
                                {{t('email-is-required')}}
                            </div>
                            <div class="error text-danger" *ngIf="authForm.get('email')!.hasError('email') && authForm.get('email')!.touched">
                                {{t('valid-email-address')}}
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('your-password')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-your-password')}}
                                </mat-label>
                                <input matInput [type]="hide ? 'password' : 'text'" id="password" formControlName="password" (keydown.enter)="onKeydown($event)">
                                <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                    <span class="material-symbols-outlined">
                                        {{hide ? 'visibility_off' : 'visibility'}}
                                    </span>
                                </button>
                            </mat-form-field>
                            <div class="error text-danger" *ngIf="authForm.get('password')!.hasError('required') && authForm.get('password')!.touched">
                                {{t('password-is-required')}}
                            </div>
                        </div>
                        <div class="info d-flex justify-content-between align-items-center">
                            <mat-checkbox>
                                {{t('remember-me')}}
                            </mat-checkbox>
                            <a routerLink="/authentication/forgot-password" class="d-inline-block text-altair">
                                {{t('forgot-password')}}
                            </a>
                        </div>
                        <button mat-button class="btn" type="submit" [disabled]="authForm.invalid">
                            {{t('sign-in')}}
                        </button>
                        <div class="error text-danger" *ngIf="showAlert">
                            {{t('invalid-credentials')}}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</ng-container>
